
import React, { useContext, useEffect, useState } from 'react'

//context
import { OrgSettingsUserGroupsContext } from '@/context/OrgSettingsUserGroupsContext';

//components
import UserIconAndName from  '@/components/elements/orgSettings/tableCellItems/UserIconAndName';
import AddToUndoButton from  '@/components/elements/global/buttons/AddToGroupButton';

//interfaces
import { AllUsersSortByType } from  '@/interfaces/orgSettings';
import { SortBy } from  '@/interfaces/toggle';
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';

//helpers
import { Truncate } from  '@/helpers/Text';
import { isExternallyManaged } from  '@/helpers/OrgSettings';



const UseAddUsersToGroupModal = () => {  
    const {setModalSortToggle, moreAvailable, modalSortToggle, searchModalUsersString, setSearchModalUsersString, isModalLoading, modalUserData, getModalUsers, userGroupName, userGroupId, removeUserFromGroup, addUserToGroup} = useContext(OrgSettingsUserGroupsContext);
    
    const [tableContent, setTableContent] = useState<ITableContent>(); 

    const noDataMessage = "There are no additional users that can be added to this group";
    const searchInputLabel = "Search";
    const backButtonText = "Back"; 
    const backButtonLabel = "Close the modal"; 
    const userDataLength = modalUserData?.length || 0;
    const columns: ITableColumn[] = [
        { title: "Username", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.USERNAME, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.USERNAME, SortBy.ASCENDING), defaultSort: SortBy.DESCENDING },
        { title: "Last Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.LAST_NAME, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.LAST_NAME, SortBy.ASCENDING), defaultSort: undefined},
        { title: "First Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.FIRST_NAME, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.FIRST_NAME, SortBy.ASCENDING), defaultSort: undefined },
    ];
    const modalTitle = `Add Users to ${userGroupName}`;

    useEffect(() => {
        getModalUsers('new'); 
    },[]);

    useEffect(() => {
        getModalUsers('new'); 
    },[modalSortToggle[0], modalSortToggle[1], searchModalUsersString]);

    useEffect(() => {
        let rows: ITableRows[] = [];
        modalUserData?.forEach((user) => {
            const row: ITableRows = {
                content: [
                    <UserIconAndName 
                        profilePicture={user.profilePicUrl} 
                        userId={user.id} 
                        username={user.userName} 
                        truncate={30}
                        isManagedUser={isExternallyManaged(user.userManagementType)}
                        externalLoginIcon={user.provider?.iconUrl}
                    />,
                    Truncate(user.lastName ?? "", 16),
                    <>
                    {<span className='firstname'>{Truncate(user.firstName ?? "", 14)}</span>}
                    <AddToUndoButton id={user.id} buttonText={'Add To Group'} ariaLabel={'Add User to the group'} onButtonClick={() => addUserToOrgGroup(user.id)} onUndoClick={()=>removeUserFromOrgGroup(user.id)} className='basic-add-to-group-button' />
                    </>
                ]};
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns});
    }, [modalUserData]);

    function toggleSort(sortByType: AllUsersSortByType, sortBy: SortBy) {
        setModalSortToggle([sortByType, sortBy]);
    }
    
    function getMoreUsers(){
        getModalUsers('paginate')
    }

    function addUserToOrgGroup(userId: any){
        addUserToGroup(userId, userGroupId);
    }

    function removeUserFromOrgGroup(userId: any){
        removeUserFromGroup(userId, userGroupId);
    }
    
    return {searchInputLabel, searchModalUsersString, setSearchModalUsersString, backButtonText, backButtonLabel, isModalLoading, noDataMessage, moreAvailable, getMoreUsers, userDataLength, tableContent, userGroupName, modalTitle }
}

export default UseAddUsersToGroupModal